import {
  get,
  post,
  error
} from '@/api/common.js'

function getInfo(path, that) {
  get(path).then(function(Response) {
    that.name = Response.data.name
    that.showname1 = Response.data.showname1
    that.showname2 = Response.data.showname2
    that.showname3 = Response.data.showname3
    that.showname4 = Response.data.showname4
    that.phone = Response.data.phone
    that.telephone = Response.data.telephone
    that.logoUrl = Response.data.logoUrl
    that.factoryUrl = Response.data.factoryUrl
    that.contactUrl = Response.data.contactUrl
    that.nid1 = Response.data.nid1
    that.nid2 = Response.data.nid2
    that.nid3 = Response.data.nid3
    that.nid4 = Response.data.nid4
    that.address = Response.data.address
    that.email = Response.data.email
    that.postalCode = Response.data.postalCode
    that.qq = Response.data.qq
  }, function(Response) {
    error(Response);
  });
}

function topSearch(path) {
  get(path).then(function(Response) {
    console.log(Response.data)
  }, function(Response) {
    error(Response);
  });
}

export {
  getInfo,
  topSearch,
}



// WEBPACK FOOTER //
// ./src/api/top.js